import { Routing } from 'app/Routing'
import { observer } from 'mobx-react-lite'
import { createRoot } from 'react-dom/client'

export const App = observer(() => {
  return <Routing />
})

export function renderApp() {
  const container = document.getElementById('root')!
  const root = createRoot(container)
  root.render(<App />)
}
